<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    this.stop();
  },
  methods: {
    stop() {
      this.$confirm(
        "该功能须另行签署代发协议方可开通，详情请<a title='邮箱地址：769319435.qq.com' href='mailto:769319435.qq.com'> 联络我们</a>！<p>邮箱地址：769319435.qq.com</p>",
        "提示",
        {
          confirmButtonText: "确定",
          dangerouslyUseHTMLString: true,
          cancelButtonText: "取消",
          showCancelButton: false,
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$router.push("/home");
        })
        .catch(() => {
          this.$router.push("/home");
        });
    },
  },
};
</script>

<style lang="less" scoped>
</style>